var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, PacemEventTarget, Watch, PropertyConverters } from '@pacem/pacem-core';
//namespace Pacem.Components.Media {
let PacemAudioElement = class PacemAudioElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._endedHandler = (e) => {
            this.dispatchEvent(new Event('end'));
        };
        this._canPlayHandler = (e) => {
            this.#canPlay = true;
            this._autoplay();
        };
        this._canPlayThroughHandler = (e) => {
            this.#canPlayThrough = true;
            this._autoplay();
        };
    }
    // TODO: structure a proper MediaElement hierarchy (share logic with a future VideoElement)
    /** @readonly */
    // @Watch({ converter: PropertyConverters.Boolean }) duration: number;
    #audio;
    #canPlay;
    #canPlayThrough;
    connectedCallback() {
        super.connectedCallback();
        const a = this.#audio = new Audio();
        a.addEventListener('canplay', this._canPlayHandler, false);
        a.addEventListener('ended', this._endedHandler, false);
        a.addEventListener('canplaythrough', this._canPlayThroughHandler, false);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'src':
                    this._init();
                    break;
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._init();
    }
    disconnectedCallback() {
        const a = this.#audio;
        a.removeEventListener('ended', this._endedHandler, false);
        a.removeEventListener('canplaythrough', this._canPlayThroughHandler, false);
        a.removeEventListener('canplay', this._canPlayHandler, false);
        super.disconnectedCallback();
    }
    play() {
        // sudden exit when disabled
        if (this.disabled) {
            return Promise.reject('disabled');
        }
        return this.#audio.play().then(_ => {
            this.dispatchEvent(new Event('start'));
        }, e => {
            this.dispatchEvent(new CustomEvent('error', { detail: e }));
        });
    }
    pause() {
        this.#audio.pause();
    }
    reset() {
        this.#audio.load();
    }
    get _canPlay() {
        return this.stream && this.#canPlay || this.#canPlayThrough;
    }
    _autoplay() {
        if (this.autoplay) {
            if (this._canPlay) {
                this.play();
            }
        }
    }
    _init(src = this.src) {
        const audio = this.#audio;
        this.#canPlay =
            this.#canPlayThrough = false;
        audio.src = src;
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemAudioElement.prototype, "src", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemAudioElement.prototype, "stream", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemAudioElement.prototype, "autoplay", void 0);
PacemAudioElement = __decorate([
    CustomElement({ tagName: P + '-audio' })
], PacemAudioElement);
export { PacemAudioElement };
